<template>
  <v-dialog v-model="dialog" persistent max-width="1600px">
    <v-form ref="form" v-model="valid">
      <v-card>
        <v-card-text>
          <v-container>
            <v-row dense v-if="hasMB" class="grey lighten-3">
              <v-select
                :items="mbs"
                label="Doplňujúce informácie k meraniu"
                v-model="meranie.MbID"
                item-value="ID"
                clearable
                :disabled="!editable"
              >
                <template slot="selection" slot-scope="{ item }">
                  {{ item.ID }} - {{ item.Poznamka }}
                </template>
                <template v-slot:item="{ item }">
                  <v-list-item-content>
                    <v-list-item-title v-text="item.ID"></v-list-item-title>
                    <v-list-item-subtitle>
                      <b>Dátum od:</b> {{ item.DatumOdString }}
                    </v-list-item-subtitle>
                    <v-list-item-subtitle>
                      <b>Dátum do:</b> {{ item.DatumDoString }}
                    </v-list-item-subtitle>
                    <v-list-item-subtitle>
                      <b>Poznámka:</b> {{ item.Poznamka }}
                    </v-list-item-subtitle>
                  </v-list-item-content>
                </template>
              </v-select>
            </v-row>
            <v-row dense v-if="itemMB !== null" class="grey lighten-3">
              <template v-for="item in meranieMBItems">
                <v-col :md="item.width" :key="item.value">
                  <span class="font-weight-black">{{ item.text }}:</span>
                  {{ showMBValue(itemMB, item) }}
                </v-col>
              </template>
              <br />
              <br />
            </v-row>
            <v-row dense>
              <template v-for="item in meranieItems">
                <v-col :cols="item.width" :key="item.text">
                  <meranie-dialog-item
                    :typ="typ"
                    :item="item"
                    :meranie="meranie"
                    v-model="meranie[item.value]"
                    :editable="editable"
                  />
                </v-col>
              </template>
            </v-row>
          </v-container>
          <!--small>*indikuje povinné polia</!--small-->
        </v-card-text>

        <v-card-actions>
          <v-btn
            color="alert"
            v-if="editable && meranie.ID !== 0"
            text
            @click="deleteMeranie()"
            >Vymazať</v-btn
          >
          <v-btn color="primary" text @click="dialog = false">Zavrieť</v-btn>
          <v-btn color="primary" v-if="editable" text @click="saveMeranie()"
            >Uložiť</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-form>
  </v-dialog>
</template>

<script>
import * as Miscella from "../plugins/miscella.js"
import * as Enums from "../plugins/enums.js"
import MeranieDialogItem from "./MeranieDialogItem.vue"
import { VTextField, VTextarea } from "vuetify/lib"

export default {
  name: "MeranieDialog",
  props: {
    typ: {
      type: String,
      required: true
    },
    editable: {
      type: Boolean,
      default: true
    }
  },
  components: { MeranieDialogItem },
  data: function() {
    return {
      dialog: false,
      meranie: { ID: 0 },
      mbs: [],
      mbUrl: "",
      oldid: "",
      valid: true
    }
  },
  computed: {
    meranieItems: function() {
      return Enums.getTypItems(this.typ)
    },
    meranieMBItems: function() {
      return Enums.getTypItems(this.itemMBTyp)
    },
    meranieUrl: function() {
      return Enums.getTableURL(this.typ)
    },
    itemComponent: function(item) {
      switch (item.typ) {
        case "text":
        case "datetime":
        case "number":
          return VTextField
        case "textarea":
          return VTextarea
      }
      return null
    },
    hasMB: function() {
      return this.mbUrl !== ""
    },
    itemMBTyp: function() {
      return Enums.getMB(this.typ)
    },
    itemMB: function() {
      let ret = null
      let mbID = this.meranie.MbID
      this.mbs.forEach(mb => {
        if (mbID === mb.ID) {
          ret = mb
        }
      })
      return ret
    }
  },
  watch: {},
  methods: {
    show: async function(aMeranie) {
      this.dialog = true
      this.meranie = Miscella.deepCloneObject(aMeranie)
      this.transformItem(this.meranie)
      this.oldid = aMeranie.ID
      await this.fetchMBs(aMeranie.BodID)
      console.log("EDIT MERANIE", aMeranie, this.mbs)
    },
    deleteMeranie: async function() {
      console.log("DELETE MERANIE", this.meranie)
      if (confirm("Naozaj vymazať meranie z databázy ?")) {
        try {
          let response = await this.$axios.delete(
            this.meranieUrl + "/" + this.meranie.ID
          )
          if (response.status === 200) {
            this.$store.commit("message", "Meranie je vymazané.")
            this.dialog = false
            this.$emit("delete")
          } else {
            this.$store.commit("alert", response.data.Error)
          }
        } catch (error) {
          this.$store.commit("alert", error.toString())
        }
      }
    },
    saveMeranie: async function() {
      console.log("SAVE MERANIE", this.meranie)
      if (this.$refs.form.validate()) {
        try {
          let meranie = this.transformItemForSave(this.meranie)
          let response = await this.$axios.post(this.meranieUrl, {
            oldID: this.oldid,
            mer: meranie
          })
          if (response.status === 200) {
            this.$store.commit("message", "Meranie uložené")
            this.dialog = false
            this.$emit("change")
          } else {
            this.$store.commit("alert", response.data.Error)
          }
        } catch (error) {
          this.$store.commit("alert", error.toString())
        }
      } else {
        this.$store.commit("alert", "Vo formulári sú chyby")
      }
    },
    transformItemForSave: function(aMeranie) {
      console.log("transformItemForSave START", aMeranie)
      let meranie = Miscella.deepCloneObject(aMeranie)
      for (let i = 0; i < this.meranieItems.length; i++) {
        const item = this.meranieItems[i]
        if (item.typ === "datetime") {
          let val = meranie[item.value]
          if (val === "") {
            meranie[item.value] = "0001-01-01T00:00:00Z"
          }
        }
      }
      console.log("transformItemForSave END", meranie)
      return meranie
    },
    fetchMBs: async function(bodID) {
      this.mbUrl = Enums.getMBForBodUrl(this.typ, bodID)
      console.log("fetchMBs", this.mbUrl, this.typ)
      if (this.mbUrl !== "") {
        try {
          let response = await this.$axios.get(this.mbUrl)
          if (response.status === 200) {
            this.mbs = this.transformItems(response.data)
          } else {
            this.$store.commit("alert", response.data.Error)
          }
        } catch (error) {
          this.$store.commit("alert", error.toString())
        }
      }
    },
    transformItems: function(items) {
      items.forEach(item => {
        this.transformItem(item)
      })
      return items
    },
    transformItem: function(item) {
      console.log("transformItem START", item)
      item.DatumString = Miscella.formatDatumACas(item.Datum)
      item.DatumOdString = Miscella.formatDatumACas(item.DatumOd)
      item.DatumDoString = Miscella.formatDatumACas(item.DatumDo)
      //item.Datum = Miscella.formatDatumACas(item.Datum)
      //item.DatumOd = Miscella.formatDatumACas(item.DatumOd)
      //item.DatumDo = Miscella.formatDatumACas(item.DatumDo)
      console.log("transformItem END", item)
    },
    showMBValue: function(itemMB, itemDef) {
      //console.log("showMBValue", itemMB, itemDef)
      let ret = itemMB[itemDef.value]
      if (itemDef.value === "DatumOd") {
        ret = itemMB["DatumOdString"]
      }
      if (itemDef.value === "DatumDo") {
        ret = itemMB["DatumDoString"]
      }
      if (itemDef.value === "Datum") {
        ret = itemMB["DatumString"]
      }
      if (itemDef.typ === "boolean") {
        ret = ret ? "Áno" : "Nie"
      }
      return ret
    }
  }
}
</script>
